module.exports = __webpack_public_path__ + "static/media/ar_logo.ebf60d5a.svg";